// extracted by mini-css-extract-plugin
module.exports = {"scrollDiv":"styles_scrollDiv__1aQAt"};